export default "__VITE_ASSET__CVzJfQEQ__"